import { api } from 'helpers/api'
import { useMutation } from 'react-query'

export const useUnMuteThread = () => {
    return useMutation({
        mutationFn: api.thread.unMuteThread,
        mutationKey: ['threadMuteToggle'],
    })
}
